import React from 'react';
import { Button } from '@fluentui/react-components';
import { ArrowLeft24Regular } from '@fluentui/react-icons';
import { useNavigate } from 'react-router-dom';

import type { BackButtonProps } from '../../types/BackButtonProps';

/**
 * Reusable back button component with consistent styling and behavior
 */
export const BackButton: React.FC<BackButtonProps> = ({
  onClick,
  className = 'screen-back-button',
  ariaLabel = 'Go back',
  tabIndex
}) => {
  const navigate = useNavigate();

  const handleClick = onClick || (() => navigate(-1));

  return (
    <Button 
      icon={<ArrowLeft24Regular />}
      appearance="subtle"
      onClick={handleClick}
      className={className}
      aria-label={ariaLabel}
      tabIndex={tabIndex}
    />
  );
};

export default BackButton;